import { useCallback } from "react";

export const useFetchData = () => {
  const fetchData = useCallback(
    async (url, method = "GET", isBlob = false, body = null) => {
      let isResponseOK = false;
      let data;
      let errorMessage = null;

      try {
        const currentToken = localStorage.getItem("sensei-user-token");
        let headers = {
          Authorization: `Bearer ${currentToken}`,
        };

        if (!isBlob && body) {
          headers["Content-Type"] = "application/json";
        }

        const response = await fetch(url, {
          method: method,
          body: body,
          headers: headers,
        });

        if (response.status === 401) {
          return { isResponseOK, data: null, errorMessage: "Unauthorized" };
        }

        data = isBlob ? await response.blob() : await response.json();
        isResponseOK = response.ok;

        if (!isResponseOK) {
          errorMessage = Array.isArray(data.detail)
            ? data.detail[0]?.msg
            : data.detail;
        }
      } catch (error) {
        return {
          isResponseOK,
          data: null,
          errorMessage: error.message || error,
        };
      }

      return { isResponseOK, data, errorMessage };
    },
    [],
  );

  return fetchData;
};
